import { MultiMediaBasicInfo } from './MultiMediaBasicInfo';

export class IndividualMultiMediaViewModel{
    id :number;
    selectedMultimediaId: number;
    media: MultiMediaBasicInfo[] ;   
}